import ConnectionType from '@jbrowse/core/pluggableElementTypes/ConnectionType';
// locals
import modelFactory from './model';
import configSchema from './configSchema';
export default (function (pluginManager) {
  pluginManager.addConnectionType(function () {
    return new ConnectionType({
      name: 'JBrowse1Connection',
      configSchema: configSchema,
      stateModel: modelFactory(pluginManager),
      displayName: 'JBrowse 1 Data',
      description: 'A JBrowse 1 data directory',
      url: '//jbrowse.org/'
    });
  });
});